@if (alert._id) {
  <div class="modal fade" id="edit-alert-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form #editAlertForm="ngForm">
            <div class="d-flex flex-column">
              <div class="form-group">
                <label>Alert name <span class="text-danger small">(required)</span></label>
                <input type="text" class="form-control" [ngClass]="setClassInvalidTpl(alertName)" #alertName="ngModel" name="name"
                  [(ngModel)]="alert.name" placeholder="Alert name" required>
              </div>
              <div class="form-group">
                <label>Keywords @if (!alert.query.person) {
                  <span class="text-danger small me-1">(required)</span>
                }
                @if (alert.query.keyword.length === 1000) {
                  <small class="text-danger">{{errorMessages.queryTooLong}}</small>
                }
              </label>
              <textarea class="form-control" rows="3" [ngClass]="{ 'is-touched': alert.query.keyword }"
              name="keyword" maxlength="1000" [(ngModel)]="alert.query.keyword" placeholder="eg: PNRR"></textarea>
            </div>
            <div class="form-group">
              <label>Users @if (!alert.query.keyword) {
                <span class="text-danger small me-1">(required)</span>
              }
              @if (alert.query.person.length === 1000) {
                <small class="text-danger">{{errorMessages.queryTooLong}}</small>
              }
            </label>
            <input type="text" class="form-control" [ngClass]="{ 'is-touched': alert.query.person }"
              name="person" maxlength="1000" [(ngModel)]="alert.query.person" placeholder="eg: Meloni">
          </div>
          <div class="form-group">
            <label>Exclude users
              @if (alert.query.noperson.length === 1000) {
                <small class="text-danger">{{errorMessages.queryTooLong}}</small>
              }
            </label>
            <input type="text" class="form-control" [ngClass]="{ 'is-touched': alert.query.noperson }"
              name="noperson" maxlength="1000" [(ngModel)]="alert.query.noperson" placeholder="Eg: Lannutti">
          </div>
          <div class="form-group">
            <label>Sources</label>
            <i class="fa fa-info-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="No source selected is equal to all sources"></i>
            <div class="btn-group-toggle" data-bs-toggle="buttons">
              @for (source of sourcesFixed; track source) {
                <label class="btn btn-outline-primary me-1 mt-1 mt-sm-0" [ngClass]="{ 'active': alert.query.source.includes(source) }">
                  <input type="checkbox" name="alertSources" (change)="checkSourceAlert(alert, source)" [checked]="alert.query.source.includes(source)">
                  {{formatSource(source)}} <i class="fa" [ngClass]="{ 'fa-square-o': !alert.query.source.includes(source), 'fa-check-square-o': alert.query.source.includes(source) }"></i>
                </label>
              }
            </div>
          </div>
          <div class="form-group">
            <label>Language</label>
            <select class="form-control" name="lang" [(ngModel)]="alert.query.lang">
              <option value="">Any language</option>
              <option value="en">English</option>
              <option value="it">Italian</option>
            </select>
          </div>
          <div class="form-group">
            <label>Party</label>
            <select class="form-control" name="party" [(ngModel)]="alert.query.party">
              <option value="">Any party</option>
              <optgroup label="Italy">
                @for (party of parties; track party) {
                  <option [value]="party._id">{{party.name}}</option>
                }
              </optgroup>
              <optgroup label="EU">
                @for (party of partiesEU; track party) {
                  <option [value]="party._id">{{party.name}}</option>
                }
              </optgroup>
            </select>
          </div>
          <div class="form-group">
            <label>Organ</label>
            <i class="fa fa-question-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Politician's organ"></i>
            <select class="form-control" name="organ" [(ngModel)]="alert.query.organ">
              <option value="">Any organ</option>
              @for (organ of organs; track organ) {
                <option [value]="organ">{{organ}}</option>
              }
            </select>
          </div>
          <div class="form-group">
            <label>Commission</label>
            <i class="fa fa-question-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Document or politician's commission"></i>
            <select class="form-control" name="commission" [(ngModel)]="alert.query.commission">
              <option value="">Any commission</option>
              @for (commission of commissions; track commission) {
                <option [value]="commission._id">
                  {{commission.roman}} - {{commission.name}} ({{commission.organ | flu}})
                </option>
              }
            </select>
          </div>
          <div class="form-group">
            <label>MEP Country</label>
            <i class="fa fa-question-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="MEP Country (EU only)"></i>
            <select class="form-control" name="country" [(ngModel)]="alert.query.country">
              <option value="">Any country</option>
              @for (country of euCountries; track country) {
                <option [value]="country">{{country}}</option>
              }
            </select>
          </div>
          <div class="form-group">
            <label class="me-1">Team: <span class="text-danger small">(required)</span></label>
            <app-search-input [items]="alert._users" model="user"></app-search-input>
          </div>
          <div class="form-group">
            <label>Status</label>
            <i class="fa fa-info-circle ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Toggle email notifications"></i>
            <select class="form-control" name="status" [(ngModel)]="alert.status">
              <option value="" disabled>Select status</option>
              <option value="on">On</option>
              <option value="off">Off</option>
            </select>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <app-spinner [condition]="isLoading.valid"></app-spinner>
      <div class="d-flex flex-column ms-1 mb-1">
        @if (wildcardInQuotes()) {
          <small class="text-danger">{{errorMessages.wildcardInQuotes}}</small>
        }
        @if (!parenthesisAreEven()) {
          <small class="text-danger">{{errorMessages.parenthesisAreEven}}</small>
        }
        @if (!doubleQuotesAreEven()) {
          <small class="text-danger">{{errorMessages.doubleQuotesAreEven}}</small>
        }
      </div>
      <button type="button" class="btn btn-success"
        [disabled]="!editAlertForm.form.valid || isModalInvalid()"
        (click)="validateAlert(alert)">
        <i class="fa fa-check-circle"></i> Validate
      </button>
      <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
        [disabled]="!editAlertForm.form.valid || isModalInvalid() || !isAlertValid"
        (click)="updateAlert(alert)">
        <i class="fa fa-floppy-o"></i> Save
      </button>
    </div>
  </div>
</div>
</div>
}